import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { IPublishCollabDialogData } from '../../models/collaboration/IPublishCollabDialogData';
import { CONSTANTS } from '../../Constants/Constants';
import { PublishCollabDataDialogComponent } from '../../Components/dialogs/common/publish-collab-data-dialog/publish-collab-data-dialog.component';
import { DiscardCollabDialogComponent } from '../../Components/dialogs/common/discard-collab-dialog/discard-collab-dialog.component';

type CollabDialogResult = 'published' | 'discarded';
@Injectable({
  providedIn: 'root'
})
export class CollabDialogDataService {
  private readonly publishedSubject = new BehaviorSubject<boolean>(false);
  isPublished$ = this.publishedSubject.asObservable();
  
  private readonly dialogConfig = {
     width: CONSTANTS.COLLABORATION_POPUP_WIDTH,
     disableClose: true
   };
   
  constructor(private readonly dialog: MatDialog) { }

  setPublished(state: boolean) {
    this.publishedSubject.next(state);
  }

  openPublishDialog(){
      const ref = this.dialog.open<PublishCollabDataDialogComponent, undefined, CollabDialogResult>(
    PublishCollabDataDialogComponent,
    this.dialogConfig
  );
  ref.afterClosed().subscribe(result => {
    if (result === CONSTANTS.PUBLISHED) {
      this.setPublished(true);
    }
  });
    }

  /** Opens the modification notes dialog for the close flow; resolves true if the estimate can be closed. */
  async publishWithNotes(data: IPublishCollabDialogData): Promise<boolean> {
    const ref = this.dialog.open(PublishCollabDataDialogComponent, { ...this.dialogConfig, data: { ...data, closeOnFailure: true } });
    const result = await firstValueFrom(ref.afterClosed());
    return result === CONSTANTS.PUBLISH_FAILED || (typeof result === 'object' && result?.modificationNotes !== undefined);
  }

  /** Opens the discard confirmation for the close flow; resolves true if the estimate can be closed. */
  async confirmDiscardBeforeClose(): Promise<boolean> {
    const ref = this.dialog.open(DiscardCollabDialogComponent, { ...this.dialogConfig, data: { isEstimateClosing: true } });
    const result = await firstValueFrom(ref.afterClosed());
    return result === CONSTANTS.DISCARDED || result === CONSTANTS.DISCARD_FAILED;
  }

  discardCollabChanges() {
    const ref = this.dialog.open<DiscardCollabDialogComponent, undefined, CollabDialogResult>(
      DiscardCollabDialogComponent,
      this.dialogConfig
    );
    ref.afterClosed().subscribe((result: string) => {
      if (result === CONSTANTS.DISCARDED) {
        this.setPublished(true); 
      }
    });
  }

  /**
   * Resets the collaboration published state.
   * Called when the user closes an estimate/project.
   */
  resetEstimateState(): void {
    this.publishedSubject.next(false);
  }
}
